export function reviveTq5PortCallDate(key: string, value: unknown): unknown {
  if ((key !== "fromDate" && key !== "toDate") || typeof value !== "string") return value;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
